export default __webpack_public_path__ + "static/media/large-circle-r.3486dd44.svg";